import { Injectable } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { FavouritesDashboardUrlParam } from '@frontend/sports/navigation/core/feature/url-helper';

@Injectable({ providedIn: 'root' })
export class TranslatorService {
    private teamSports: number[] = [
        4, 7, 11, 12, 16, 18, 22, 23, 27, 28, 31, 32, 36, 47, 48, 49, 52, 53, 54, 55, 63, 65, 68, 70, 71, 73, 74, 77, 85, 88, 93, 97,
    ];

    private playerSports: number[] = [
        5, 6, 9, 10, 13, 24, 30, 33, 34, 35, 38, 39, 40, 41, 42, 43, 44, 45, 46, 50, 51, 56, 57, 58, 59, 64, 66, 67, 69, 72, 75, 76, 78, 79, 80, 81,
        82, 83, 84, 86, 87, 89, 91, 92, 94, 95, 96,
    ];

    constructor(private sitecore: Sitecore) {}

    translate(tab: string, sportId: number, sportName: string): string {
        let siteCoreItem = '';
        switch (tab) {
            case FavouritesDashboardUrlParam.Competitions:
                siteCoreItem = this.sitecore.favouritesDashboard.CompetitionHeader;
                break;
            case FavouritesDashboardUrlParam.Events:
                siteCoreItem = this.sitecore.favouritesDashboard.EventsHeader;
                break;
            case FavouritesDashboardUrlParam.Upcoming:
                siteCoreItem = this.sitecore.favouritesDashboard.SportHeader;
                break;
            case FavouritesDashboardUrlParam.Players:
                siteCoreItem = this.getParticipantTranslationKey(sportId);
                break;
        }

        return siteCoreItem.replace('{sport}', sportName);
    }

    private getParticipantTranslationKey(sportId: number): string {
        if (this.teamSports.indexOf(sportId) !== -1) {
            return this.sitecore.favouritesDashboard.TeamsHeader;
        } else if (this.playerSports.indexOf(sportId) !== -1) {
            return this.sitecore.favouritesDashboard.PlayersHeader;
        } else {
            return '{sport}';
        }
    }
}
